import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import QRScanner from './QRScanner';

interface CameraProps {
  onClose: () => void;
}

const Camera: React.FC<CameraProps> = ({ onClose }) => {

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
            <div className="bg-gradient-to-r from-customBg via-customBg2 to-customBg/80 px-3 py-3 rounded relative">
            <button
                className="text-white bg-gradient-to-br from-custom36p via-custom36s/60 to-custom36s hover:bg-gradient-to-r focus:ring-4 focus:outline-none focus:ring-custom36p shadow-lg shadow-custom36p/50 font-medium rounded-lg border-none text-sm px-3 py-1 text-center"
                onClick={onClose}
                >
                    ZAMKNIJ
            </button>
            <QRScanner onClose={onClose}/>
            </div>
        </div>
    );
};

export default Camera;
